import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  href?: string;
}
export function CTAButton({
  text = '¡SÍ! QUIERO ELIMINAR MI DOLOR AHORA',
  subtext = 'Acceso instantáneo después del pago seguro.',
  className = '',
  href = '#pricing-section'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const isPageHash = href === '#checkout' || href === '#thankyou' || href === '';
  const isScrollHash = !isExternal && !isPageHash && href.startsWith('#');
  const handleClick = (e: React.MouseEvent) => {
    // Fire Meta Pixel AddToCart event on checkout clicks
    if (isExternal && typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'Protocolo SOS Nervio Ciático',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    if (isExternal) {
      return;
    }
    e.preventDefault();
    if (isPageHash) {
      window.location.hash = href;
    } else if (isScrollHash) {
      const id = href.replace('#', '');
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-26">
      <motion.a href={isExternal ? href : undefined} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} animate={{
      boxShadow: ['0px 0px 0px rgba(227, 100, 20, 0)', '0px 0px 20px rgba(227, 100, 20, 0.4)', '0px 0px 0px rgba(227, 100, 20, 0)']
    }} transition={{
      boxShadow: {
        duration: 2,
        repeat: Infinity
      },
      scale: {
        duration: 0.2
      }
    }} onClick={handleClick} className="w-full max-w-md bg-orange hover:bg-orange-hover text-white font-body font-bold text-lg md:text-xl py-4 md:py-5 px-6 rounded-lg shadow-lg uppercase tracking-wide transition-colors text-center block cursor-pointer no-underline" data-id="element-27">
        {text}
      </motion.a>
      <div className="flex items-center mt-3 text-sm text-warm-gray opacity-90" data-id="element-28">
        <Shield className="w-4 h-4 mr-1.5 text-green" data-id="element-29" />
        <span data-id="element-30">{subtext}</span>
      </div>
    </div>;
}